module.exports = __webpack_public_path__ + "img/partnership-manage-account.1069f0d.png";